import { ShieldCheck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { usePrimaryAdmin } from '@/api/hooks/useSettings';

// Shared read-only reference to the org's designated Primary Admin (read from the tenant-facing
// GET /team/primary-admin — the oldest active user, mirroring the admin-portal card). Read-only by
// design: changing it goes through Support (no reassignment control — clear of role-semantics).
// Reused on the Team (Users & Permissions) page and the Escalation Contacts page.
export function PrimaryAdminReferenceCard() {
  const { data: admin, isLoading } = usePrimaryAdmin();
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-text-muted" /> Primary Technical Contact
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-16 w-full" />
        ) : !admin ? (
          <p className="text-sm text-text-muted">No primary technical contact on record.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <div>
              <p className="text-xs text-text-muted">Name</p>
              <p className="text-text-primary mt-0.5">
                {[admin.firstName, admin.lastName].filter(Boolean).join(' ') || admin.displayName || '—'}
              </p>
            </div>
            <div>
              <p className="text-xs text-text-muted">Email</p>
              <p className="text-text-primary mt-0.5 break-all">{admin.email}</p>
            </div>
            <div>
              <p className="text-xs text-text-muted">Status</p>
              <p className="mt-0.5">
                <Badge variant={admin.status === 'active' ? 'emerald' : 'muted'} className="text-[10px]">{admin.status}</Badge>
              </p>
            </div>
          </div>
        )}
        <p className="text-xs text-text-secondary mt-3 pt-3 border-t border-border-subtle">
          To change your organization’s Primary Technical Contact, please contact Support.
        </p>
      </CardContent>
    </Card>
  );
}
